<template>
	<div>
		<v-container :class="deviceClass">
			<PageTitle icon="mdi-clock-time-four" main="Registro de Ponto" sub="" />

			<!-- Painel de Status -->
			<v-card flat class="background mb-4 pro-status">
				<v-card-text class="pa-4">
					<v-row align="center">
						<v-col cols="12" md="6">
							<div class="d-flex align-center">
								<v-icon color="primary" class="mr-3">mdi-account-circle</v-icon>
								<div>
									<div class="text-h6 font-weight-regular">{{ user.nome }}</div>
									<div class="text-caption secondary--text text--lighten-1">Funcionário</div>
								</div>
							</div>
						</v-col>

						<v-col cols="12" md="6" class="text-right">
							<div class="text-h5 font-weight-light secondary--text">{{ dataHoraAtual }}</div>
							<div class="text-caption secondary--text text--lighten-1">Data e Hora Atual</div>
						</v-col>
					</v-row>
				</v-card-text>

			</v-card>

			<v-row>
				<!-- Reconhecimento Facial -->
				<v-col v-if="reconhecimentoFacialAtivo" cols="12" :md="isMobile ? 12 : 5">
					<v-card flat class="pro-card">
						<v-card-title class="secondary--text font-weight-regular pb-2">
							Reconhecimento Facial
						</v-card-title>
						<v-divider />
						<v-card-text class="pa-4 text-center">
							<FaceApi
							:captura="captura"
							@face-recognized="onFaceRecognized"
							@photo-captured="onPhotoCaptured"
							@photo-registered="onPhotoRegistered"
							/>
						</v-card-text>
					</v-card>
				</v-col>

				<!-- Registro de Pontos -->
				<v-col cols="12" :md="reconhecimentoFacialAtivo ? (isMobile ? 12 : 7) : 12">
					<v-card flat class="pro-card">
						<v-card-title class="secondary--text font-weight-regular pb-2">
							Registros do Dia
							<v-spacer />
							<v-btn text small @click="loadCargaHoraria(user.idfuncionario)">
								<v-icon left small>mdi-history</v-icon>
								Histórico
							</v-btn>
						</v-card-title>
						<v-divider />

						<v-card-text class="pa-4">
							<div class="mb-3" v-if="isMobile">
								<div class="text-caption secondary--text text--lighten-1 mb-1">
									Localização Atual
								</div>
								<div class="text-body-2">
									{{ formattedAddress || "Obtendo localização..." }}
								</div>
							</div>

							<!-- Cards (visual profissa + botões alinhados) -->
							<v-row dense>
								<v-col
								v-for="card in pointCards"
								:key="card.key"
								:cols="isMobile ? 6 : 6"
								:md="isMobile ? 6 : 3"
								>
								<div class="point-card point-card--pro">
									<div class="point-header">
										<div class="point-label">{{ card.label }}</div>

										<v-chip
										x-small
										label
										class="point-chip"
										:class="ponto?.[card.key] ? 'chip-done' : 'chip-pending'"
										>
										{{ ponto?.[card.key] ? "OK" : "Pendente" }}
									</v-chip>
								</div>

								<div class="point-time point-time--pro">
									{{ ponto?.[card.key] || "--:--" }}
								</div>
								<div class="point-just-wrap" v-if="getJustificativa(card)">
									<v-tooltip bottom max-width="320">
										<template v-slot:activator="{ on, attrs }">
											<v-chip
											x-small
											outlined
											class="just-chip"
											v-bind="attrs"
											v-on="on"
											@click.stop="openJustView(card)"
											>
											<v-icon left x-small>mdi-text-box-outline</v-icon>
											{{ justificativaPreview(card) }}
										</v-chip>
									</template>

									<div class="just-tooltip">
										<div class="just-tooltip-title">{{ card.label }}</div>
										<div class="just-tooltip-body">{{ getJustificativa(card) }}</div>
										<div class="just-tooltip-hint">Clique para abrir</div>
									</div>
								</v-tooltip>
							</div>

							<!-- Reservado para manter alturas consistentes -->
							<div class="point-meta">
								<span v-if="card.requires?.length">
									<v-icon x-small class="mr-1">mdi-lock-outline</v-icon>
									Depende de: {{ card.requiresLabels }}
								</span>
								<span v-else>&nbsp;</span>
							</div>

							<div class="point-actions">
								<v-btn
								block
								small
								depressed
								class="btn-pro"
								color="primary"
								:loading="loading"
								:disabled="isButtonDisabled(card)"
								@click="onRegistrarClick(card.tipo)"
								>
								<v-icon left small>
									{{ reconhecimentoFacialAtivo ? "mdi-face-recognition" : "mdi-fingerprint" }}
								</v-icon>
								Registrar
							</v-btn>
						</div>
					</div>
				</v-col>
			</v-row>

			<p v-if="lastFormattedAddress" class="mt-3 text-caption secondary--text">
				{{ lastFormattedAddress }}
			</p>
		</v-card-text>
	</v-card>
</v-col>
</v-row>

<!-- Diálogo Histórico -->
<v-dialog v-model="dialogoVerTodos" max-width="900px">
	<v-card>
		<v-card-title class="primary white--text">
			<v-icon left color="white">mdi-history</v-icon>
			Histórico de Registros
		</v-card-title>

		<v-card-text class="pa-0">
			<v-data-table :items="cargahoraria" :headers="table" class="elevation-0">
				<template v-slot:item.data="{ item }">
					{{ formatoData(item.data) }}
				</template>
				<template v-slot:item.horas_trabalhadas="{ item }">
					{{ formatoHoras(item.horas_trabalhadas) }}
				</template>
			</v-data-table>
		</v-card-text>
	</v-card>
</v-dialog>
<v-dialog v-model="dialogJust" max-width="520">
	<v-card>
		<v-card-title class="secondary--text">
			<v-icon left>mdi-text-box-edit-outline</v-icon>
			Justificativa
		</v-card-title>

		<v-card-text class="pt-2">
			<div class="text-caption secondary--text mb-2">
				Registro: <strong>{{ dialogCard?.label }}</strong>
			</div>

			<v-textarea
			v-model="dialogJustText"
			outlined
			auto-grow
			rows="3"
			label="Escreva a justificativa (opcional)"
			counter="250"
			maxlength="250"
			/>
		</v-card-text>

		<v-card-actions>
			<v-spacer />
			<v-btn text @click="closeJustDialog">Cancelar</v-btn>
			<v-btn color="primary" depressed :loading="loading" @click="confirmJustDialog">
				Confirmar e Registrar
			</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>
<v-dialog v-model="dialogJustView" max-width="520">
	<v-card>
		<v-card-title class="secondary--text">
			<v-icon left>mdi-text-box</v-icon>
			Justificativa
		</v-card-title>

		<v-card-text>
			<div class="text-caption secondary--text mb-2">
				Registro: <strong>{{ viewCard?.label }}</strong>
			</div>

			<div class="just-full">
				{{ viewText }}
			</div>
		</v-card-text>

		<v-card-actions>
			<v-spacer />
			<v-btn color="primary" depressed @click="dialogJustView = false">
				Fechar
			</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>

</v-container>
</div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, showError } from "@/global";
import { mapState } from "vuex";
import moment from "moment-timezone";
import Bus from "@/barramento";
import PageTitle from "@/templates/PageTitle";
import FaceApi from "@/components/Faceapi";
import deviceDetection from "@/mixins/deviceDetection";

export default {
	name: "MeuPonto",
	components: { PageTitle, FaceApi },
	mixins: [deviceDetection],

	data() {
		return {
			dialogJustView: false,
			viewCard: null,
			viewText: "",

			dialogJust: false,
			dialogJustText: "",
			dialogCard: null,
			pendingFotoAtual: null,
			pendingTipoPonto: null,
			pendingJustificativa: "",
			ponto: { justificativas: {} },
			saldo: "00:00",
			isNegative: false,

      // pausa (mantida)
			onPause: false,
			progress: 100,
			pauseInterval: null,
			pauseLimit: 15 * 60,
			startTime: null,
			elapsedPause: 0,
			excessTime: 0,
			period: "",

      // histórico
			cargahoraria: [],
			dialogoVerTodos: false,

			dataHoraAtual: "",
			timerClock: null,

			table: [
				{ text: "Data", value: "data" },
				{ text: "Entrada", value: "entrada" },
				{ text: "Saída Almoço", value: "saida_almoco" },
				{ text: "Retorno", value: "retorno" },
				{ text: "Saída", value: "saida" },
				{ text: "Horas Trabalhadas", value: "horas_trabalhadas" },
				],

      // localização
			location: null,
			formattedAddress: "",
			lastFormattedAddress: "",

      // face
			captura: null,
			reconhecimentoFacialAtivo: true,

			loading: false,
		};
	},

	computed: {
		...mapState(["user"]),

    // lista base (sem labels de requires ainda)
		pointCardsRaw() {
			return [
				{ key: "entrada", label: "Entrada", tipo: "ENTRADA", requires: [], justKey: "just_entrada" },
				{ key: "saida_almoco", label: "Saída Almoço", tipo: "SAÍDA ALMOÇO", requires: ["entrada"], justKey: "just_saida_almoco" },
				{ key: "retorno", label: "Retorno", tipo: "RETORNO", requires: ["saida_almoco"], justKey: "just_retorno" },
				{ key: "saida", label: "Saída Final", tipo: "SAÍDA FINAL", requires: ["retorno"], justKey: "just_saida" },
				{ key: "extra_entrada", label: "Entrada Extra", tipo: "ENTRADA EXTRA", requires: ["saida"], justKey: "just_extra_entrada" },
				{ key: "extra_saida", label: "Saída Extra", tipo: "SAÍDA EXTRA", requires: ["extra_entrada"], justKey: "just_extra_saida" },
				]
		},


    // cards prontos, com requires legível no meta
		pointCards() {
			const labelByKey = this.pointCardsRaw.reduce((acc, c) => {
				acc[c.key] = c.label;
				return acc;
			}, {});
			return this.pointCardsRaw.map((c) => ({
				...c,
				requiresLabels: (c.requires || []).map((k) => labelByKey[k] || k).join(", "),
			}));
		},

    // janela de horário
		isDisabled() {
			return !!this.ponto?.extra_saida
		},


    // próximo ponto (para face)
		proximoTipoPonto() {
			const next = this.pointCards.find((c) => !this.ponto?.[c.key]);
			return next?.tipo || null;
		},

		formattedTime() {
			const remainingTime = this.pauseLimit - this.elapsedPause;
			const absTime = Math.abs(remainingTime);
			const minutes = Math.floor(absTime / 60);
			const sign = remainingTime < 0 ? "-" : "";
			return `${sign}${String(minutes).padStart(2, "0")}`;
		},

		formattedExcessTime() {
			const minutes = Math.floor(this.excessTime / 60);
			return `${String(minutes).padStart(2, "0")}`;
		},

		pauseStatus() {
			if (this.onPause) return "Pausa ativa";
			return this.excessTime > 0 ? "Pausa encerrada com excedente" : "Pausa encerrada";
		},
	},

	methods: {
		justificativaPreview(card) {
			const txt = this.getJustificativa(card)
			return txt.length > 18 ? txt.slice(0, 18) + "…" : txt
		},
		openJustView(card) {
			this.viewCard = card
			this.viewText = this.getJustificativa(card)
			this.dialogJustView = true
		},


		getJustificativa(card) {
			if (!card) return ""
				const txt = this.ponto?.justificativas?.[card.key]
			return txt ? String(txt).trim() : ""
		},




    // ----------------------------
    // UI: regras de botão centralizadas
    // ----------------------------
		isButtonDisabled(card) {
			if (this.isDisabled) return true;

      // já registrado
			if (this.ponto?.[card.key]) return true;

      // pré-requisitos
			const okReq = (card.requires || []).every((k) => !!this.ponto?.[k]);
			if (!okReq) return true;

			return false;
		},

		onRegistrarClick(tipoPonto) {
  // acha o card para mostrar nome bonitinho no dialog
			const card = this.pointCards.find(c => c.tipo === tipoPonto)
			this.dialogCard = card || null
			this.dialogJustText = "" 
			this.pendingTipoPonto = tipoPonto
			this.pendingFotoAtual = null
			this.dialogJust = true
		},

		closeJustDialog() {
			this.dialogJust = false
			this.dialogJustText = ""
			this.dialogCard = null
			this.pendingFotoAtual = null
			this.pendingTipoPonto = null
		},

		async confirmJustDialog() {
  // Aqui você decide se justificativa é obrigatória:
  // if (!this.dialogJustText?.trim()) { this.$toasted.error("Informe a justificativa."); return; }

			const justificativa = (this.dialogJustText || "").trim()

  // Se face ativo: precisamos primeiro disparar a captura/reconhecimento
  // mas o POST será feito depois, com a foto (no onFaceRecognized).
			if (this.reconhecimentoFacialAtivo) {
				this.pendingJustificativa = justificativa
				this.dialogJust = false
				this.save()
				return
			}

  // sem face: registra já com justificativa
			this.dialogJust = false
			await this.registrarPontoSemFace(this.pendingTipoPonto, justificativa)
			this.closeJustDialog()
		},

    // ----------------------------
    // HISTÓRICO / PONTOS
    // ----------------------------
		loadCargaHoraria(id) {
			this.dialogoVerTodos = true;
			axios
			.get(`${baseApiUrl}/pontos/${id}`)
			.then((res) => {
				this.cargahoraria = res.data;
			})
			.catch(showError);
		},

		async loadPontos() {
			try {
    // 1) ponto do dia (seu endpoint atual)
				const { data } = await axios.get(`${baseApiUrl}/usuarios/${this.user.id}`)
				this.ponto = data && typeof data === "object" && !Array.isArray(data) ? data : {}

    // ✅ garante estrutura reativa
				if (!this.ponto.justificativas) this.$set(this.ponto, "justificativas", {})

    // 2) pega lista de expedientes do mês do funcionário
					const { data: lista } = await axios.get(`${baseApiUrl}/pontos/${this.user.idfuncionario}`)

    // defensivo
				const arr = Array.isArray(lista) ? lista : []

    // 3) tenta achar expediente de hoje
				const hoje = moment().format("YYYY-MM-DD")

    // alguns bancos retornam data como Date, outros como string "YYYY-MM-DD"
				const expHoje = arr.find(e => String(e.data).slice(0, 10) === hoje)
      // fallback: último expediente do mês
				|| arr[arr.length - 1]
				|| null

    // 4) injeta justificativas se vierem do backend
				const just = expHoje?.justificativas || expHoje?.justificativa || expHoje?.motivo || null

    // Se o backend já manda no formato certo: {entrada, saida_almoco, retorno, saida}
				if (just && typeof just === "object") {
					this.$set(this.ponto, "justificativas", just)
				} else {
      // fallback: se não veio nada, mantém {}
					this.$set(this.ponto, "justificativas", {})
				}

    // DEBUG TEMPORÁRIO
				console.log("EXP HOJE:", expHoje)
				console.log("JUSTIFICATIVAS INJETADAS:", this.ponto.justificativas)

			} catch (error) {
				console.error("Erro ao carregar pontos:", error)
			}
		},



    // ----------------------------
    // FOTO / CAPTURA
    // ----------------------------
		getUpload() {
			axios
			.get(`${baseApiUrl}/uploadFile/captura_${this.user.usuario}.png`)
			.then((res) => {
				if (res.data) {
					this.captura = `${baseApiUrl}/uploadFile/captura_${this.user.usuario}.png`;
				}
			})
			.catch(showError);
		},

    // ----------------------------
    // LOCALIZAÇÃO
    // ----------------------------
		getLocationPromise() {
			return new Promise((resolve) => {
				if (!this.isMobile) {
					this.formattedAddress = "Localização não exigida em desktop";
					resolve();
					return;
				}

				if (!navigator.geolocation) {
					this.formattedAddress = "Localização não disponível";
					resolve();
					return;
				}

				navigator.geolocation.getCurrentPosition(
					async (position) => {
						this.location = {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						};
						await this.reverseGeocode(this.location.lat, this.location.lng);
						resolve();
					},
					() => {
						this.formattedAddress = "Erro ao obter localização";
						resolve();
					},
					{ enableHighAccuracy: true, timeout: 5000, maximumAge: 60000 }
					);
			});
		},

		async reverseGeocode(lat, lng) {
			try {
				const { data } = await axios.get(`${baseApiUrl}/reverse-geocode`, {
					params: { lat, lng },
				});
				this.formattedAddress = data.results?.[0]?.formatted_address || "Endereço não encontrado";
				this.lastFormattedAddress = this.formattedAddress;
			} catch (error) {
				this.formattedAddress = "Erro ao buscar endereço";
			}
		},

    // ----------------------------
    // BANCO DE HORAS
    // ----------------------------
		async loadBancoHoras() {
			try {
				const res = await axios.get(`${baseApiUrl}/bancohoras?id=${this.user.idfuncionario}`);

				const saved = JSON.parse(localStorage.getItem(`pauseState_${this.user.idfuncionario}`)) || null;
				const excedenteSegundos = saved?.excessTime || 0;

				const totalSegundos = (Number(res.data.saldo) || 0) * 3600 - excedenteSegundos;
				this.isNegative = totalSegundos < 0;

				const abs = Math.abs(totalSegundos);
				const hh = Math.floor(abs / 3600);
				const mm = Math.floor((abs % 3600) / 60);
				const sign = totalSegundos < 0 ? "-" : "";
				this.saldo = `${sign}${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}`;
			} catch (e) {
				showError(e);
			}
		},

    // ----------------------------
    // FORMATOS
    // ----------------------------
		formatoData(data) {
			return data ? moment(data, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
		},

		formatoHoras(decimal) {
			const val = Number(decimal) || 0;
			const horas = Math.floor(val);
			const minutos = Math.floor((val - horas) * 60);
			return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
		},

    // ----------------------------
    // CONFIG
    // ----------------------------
		async loadConfiguracoes() {
			try {
				const res = await axios.get(`${baseApiUrl}/ativos`);
				const configuracoes = Array.isArray(res.data) ? res.data : [];
				const faceConfig = configuracoes.find((config) => config.nome === "reconhecimento_facial");
				const sistemaAtivo = faceConfig ? !!faceConfig.estado : false;

				const userRes = await axios.get(`${baseApiUrl}/usuarios`);
				const usuarios = Array.isArray(userRes.data) ? userRes.data : [];
				const userData = usuarios.find((u) => u.idusuarios === this.user.id);
				const usuarioAtivo = userData
				? userData.reconhecimento_facial === 1 || userData.reconhecimento_facial === true
				: false;

				this.reconhecimentoFacialAtivo = sistemaAtivo && usuarioAtivo;
			} catch (error) {
				console.error("Erro ao carregar configurações:", error);
				this.reconhecimentoFacialAtivo = false;
			}
		},

    // ----------------------------
    // REGISTRO SEM FACE
    // ----------------------------
		async registrarPontoSemFace(tipoPonto, justificativa = "") {
			try {
				this.loading = true
				await this.loadPontos()

				if (!this.formattedAddress) {
					await this.getLocationPromise()
				}

				const payload = {
					datahora: moment().format("YYYY-MM-DD HH:mm:ss"),
					local: this.formattedAddress,
					captura: null,
					tipoPonto,
					justificativa,
				}

				await axios.post(`${baseApiUrl}/pontos`, payload)
				this.$toasted.success(`${tipoPonto} registrado!`)
				await this.loadPontos()
			} catch (error) {
				const msg = error.response?.data || "Erro ao registrar ponto"
				this.$toasted.error(msg)
			} finally {
				this.loading = false
			}
		},


    // ----------------------------
    // FACE FLOW
    // ----------------------------
		save() {
			Bus.$emit("face", this.user);
		},

		async onFaceRecognized(fotoAtual) {
			try {
				this.loading = true;
				await this.loadPontos();

				const tipoPonto = this.proximoTipoPonto;
				if (!tipoPonto) {
					this.$toasted.error("Todos os pontos já foram registrados!");
					return;
				}

				if (fotoAtual) await this.salvarNovaFotoReferencia(fotoAtual);
				if (!this.formattedAddress) await this.getLocationPromise();

				const payload = {
					datahora: moment().format("YYYY-MM-DD HH:mm:ss"),
					local: this.formattedAddress,
					captura: `captura_${this.user.usuario}.png`,
					tipoPonto,
					justificativa: this.pendingJustificativa || "",
				}
				await axios.post(`${baseApiUrl}/pontos`, payload);
				this.$toasted.success(`${tipoPonto} registrado!`);
				await this.loadPontos();
			} catch (err) {
				this.$toasted.error("Erro ao Registrar Ponto!");
			} finally {
				this.loading = false;
			}
		},

		onPhotoCaptured() {
			this.loadPontos();
		},

		onPhotoRegistered() {
			this.loadPontos();
		},

		async salvarNovaFotoReferencia(fotoDataUrl) {
			try {
				const blob = this.dataURLtoBlob(fotoDataUrl);
				const formData = new FormData();
				formData.append("file", blob, `captura_${this.user.usuario}.png`);

				await axios.put(`${baseApiUrl}/uploads/${this.user.id}`, formData, {
					headers: { "Content-Type": "multipart/form-data" },
				});

				this.getUpload();
			} catch (err) {
				console.error("Erro ao salvar nova foto:", err);
			}
		},

		dataURLtoBlob(dataURL) {
			const arr = dataURL.split(",");
			const mime = arr[0].match(/:(.*?);/)[1];
			const bstr = atob(arr[1]);
			let n = bstr.length;
			const u8arr = new Uint8Array(n);
			while (n--) u8arr[n] = bstr.charCodeAt(n);
			return new Blob([u8arr], { type: mime });
		},

    // ----------------------------
    // RELÓGIO
    // ----------------------------
		startClock() {
			this.dataHoraAtual = moment().format("DD/MM/YYYY, HH:mm:ss");
			this.timerClock = setInterval(() => {
				this.dataHoraAtual = moment().format("DD/MM/YYYY, HH:mm:ss");
			}, 1000);
		},

    // ----------------------------
    // PAUSA (mantida, com travas simples)
    // ----------------------------
		togglePause() {
			const h = new Date().getHours();

			if (!this.onPause && (h < 7 || h >= 19)) {
				alert("Pausa não permitida fora do horário de trabalho.");
				return;
			}

			this.onPause = !this.onPause;
			if (this.onPause) this.startPause();
			else this.endPause();
		},

		startPause() {
			this.startTime = Date.now();
			this.pauseInterval = setInterval(this.updatePause, 1000);
			this.saveState();
		},

		resumePause() {
			this.pauseInterval = setInterval(this.updatePause, 1000);
		},

		updatePause() {
			const elapsed = Math.floor((Date.now() - this.startTime) / 1000);
			this.elapsedPause = elapsed;

			const remainingTime = this.pauseLimit - this.elapsedPause;
			this.progress = Math.max((remainingTime / this.pauseLimit) * 100, 0);

			this.excessTime = remainingTime < 0 ? Math.abs(remainingTime) : 0;
			this.saveState();
		},

		endPause() {
			clearInterval(this.pauseInterval);
			this.pauseInterval = null;
			this.saveState();
		},

		saveState() {
			const key = `pauseState_${this.user.idfuncionario}`;
			localStorage.setItem(
				key,
				JSON.stringify({
					idfuncionario: this.user.idfuncionario,
					onPause: this.onPause,
					startTime: this.startTime,
					elapsedPause: this.elapsedPause,
					excessTime: this.excessTime,
					period: this.period,
				})
				);
		},

		removeState() {
			const key = `pauseState_${this.user.idfuncionario}`;
			localStorage.removeItem(key);
			this.onPause = false;
			this.elapsedPause = 0;
			this.excessTime = 0;
		},
	},

	created() {
		const key = `pauseState_${this.user.idfuncionario}`;
		const savedState = JSON.parse(localStorage.getItem(key));
		if (savedState) {
			const { onPause, startTime, elapsedPause, excessTime, period } = savedState;

			this.onPause = onPause;
			this.startTime = startTime;
			this.elapsedPause = elapsedPause;
			this.excessTime = excessTime;
			this.period = period;

			if (this.onPause) {
				const now = Date.now();
				const elapsedSinceLastSave = Math.floor((now - this.startTime) / 1000);
				this.elapsedPause += elapsedSinceLastSave;

				const remainingTime = this.pauseLimit - this.elapsedPause;
				this.progress = Math.max((remainingTime / this.pauseLimit) * 100, 0);

				this.resumePause();
			}
		}
	},

	async mounted() {
		this.startClock();

		await Promise.all([this.loadConfiguracoes(), this.loadPontos(), this.getLocationPromise()]);

		this.loadBancoHoras();

		Bus.$on("photo-captured", this.loadPontos);
	},

	beforeDestroy() {
		if (this.timerClock) clearInterval(this.timerClock);
		if (this.pauseInterval) clearInterval(this.pauseInterval);
		Bus.$off("photo-captured", this.loadPontos);
	},
};
</script>

<style scoped>
/* “acabamento” geral */

.point-just-wrap {
	margin-top: 10px;
	display: flex;
	justify-content: center;
}

.just-chip {
	border-radius: 12px;
	max-width: 100%;
	cursor: pointer;
}

.just-tooltip {
	white-space: normal;
	line-height: 1.35;
}

.just-tooltip-title {
	font-weight: 700;
	margin-bottom: 6px;
}

.just-tooltip-body {
	opacity: 0.95;
}

.just-tooltip-hint {
	margin-top: 8px;
	font-size: 11px;
	opacity: 0.7;
}

.just-full {
	white-space: pre-wrap;
	font-size: 14px;
	line-height: 1.45;
}

.pro-card {
	border-radius: 12px;
}

.pro-status {
	border-radius: 12px;
}

/* cards do ponto */
.point-card--pro {
	position: relative;
	border: 1px solid var(--divider-color);
	border-radius: 12px;
	background: var(--surface-color);
	padding: 14px;
	height: 100%;

	display: flex;
	flex-direction: column;

	transition: box-shadow 0.2s, transform 0.2s;
}

.point-card--pro:hover {
	box-shadow: 0 8px 22px rgba(0, 0, 0, 0.1);
	transform: translateY(-1px);
}

.point-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	margin-bottom: 10px;
}

.point-label {
	font-size: 12px;
	color: var(--text-secondary);
	text-transform: uppercase;
	letter-spacing: 0.6px;
	font-weight: 700;
}

.point-chip {
	border-radius: 10px;
	font-weight: 700;
}

.chip-done {
	opacity: 0.95;
}

.chip-pending {
	opacity: 0.75;
}

.point-time--pro {
	font-size: 22px;
	font-weight: 800;
	color: var(--secondary-color);
	letter-spacing: 0.3px;

	min-height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;

	padding: 10px 8px;
	border-radius: 12px;
	background: rgba(0, 0, 0, 0.035);
}

.point-meta {
	margin-top: 10px;
	font-size: 12px;
	color: var(--text-secondary);
	display: flex;
	align-items: center;
	justify-content: center;
	opacity: 0.85;

	/* ✅ reserva espaço: evita “sobe e desce” e mantém botão alinhado */
	min-height: 18px;
}

/* ✅ botão sempre alinhado no rodapé */
.point-actions {
	margin-top: auto;
	padding-top: 12px;
}

.btn-pro {
	border-radius: 12px !important;
	height: 38px !important;
	font-weight: 800;
	letter-spacing: 0.2px;
}

/* mobile */
@media (max-width: 600px) {
	.point-card--pro {
		padding: 12px;
		border-radius: 12px;
	}

	.point-time--pro {
		font-size: 18px;
		padding: 8px 6px;
	}

	.btn-pro {
		height: 34px !important;
		font-size: 12px !important;
	}
	.point-just {
		margin-top: 8px;
		font-size: 12px;
		color: var(--text-secondary);
		display: flex;
		align-items: flex-start;
		gap: 6px;
		line-height: 1.25;

		/* não deixa o card “crescer” demais por textos longos */
		max-height: 32px;
		overflow: hidden;
	}

}
</style>
